// extracted by mini-css-extract-plugin
export default {"noResults":"EmptyState--noResults--1333fe"};